import { AuthPort } from './auth-port';

type Ubicacion = Pick<Location, 'assign'>;
type Fetch = typeof fetch;
type Aviso = (mensaje: string) => void;

/** Solo una ruta relativa propia: empieza con "/" y no con "//" (protocolo relativo a otro host). */
const esRutaRelativaPropia = (valor: string): boolean => valor.startsWith('/') && !valor.startsWith('//');

/**
 * Adaptador de sesión por cookie (FE-86, enmienda E-7): el backend es el cliente de Entra ID.
 * La consola solo sigue redirecciones completas del navegador; nunca ve ni guarda un token.
 */
export class SesionCookieAuth implements AuthPort {
  constructor(
    private readonly apiBaseUrl: string,
    private readonly ubicacion: Ubicacion = window.location,
    private readonly fetchFn: Fetch = fetch,
    private readonly avisoError: Aviso = (mensaje) => console.error(`[SesionCookieAuth] ${mensaje}`),
  ) {}

  iniciar(returnTo?: string): void {
    const query = returnTo && esRutaRelativaPropia(returnTo) ? `?returnTo=${encodeURIComponent(returnTo)}` : '';
    this.ubicacion.assign(`${this.apiBaseUrl}/v1/auth/login${query}`);
  }

  async cerrarSesion(): Promise<void> {
    // `fetch` solo rechaza ante un fallo de red: un 401/500 del backend resuelve igual, así que
    // sin este chequeo un logout fallido se vería como exitoso (la cookie seguiría viva).
    const respuesta = await this.fetchFn(`${this.apiBaseUrl}/v1/auth/logout`, { method: 'POST', credentials: 'include' });
    if (!respuesta.ok) {
      this.avisoError(`POST /v1/auth/logout respondió ${respuesta.status}; la cookie de sesión puede seguir activa.`);
    }
    this.ubicacion.assign('/');
  }
}
